import React, { useContext, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import PollListItem from "./PollListItem";
import { PostType, UserType } from "../../utils/types";
import moment from "moment";
import { IconButton, Button } from "@mui/material";
import AuthContext from "../../context/AuthContext";
import ThreadEditForm from "./ThreadEditForm";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReplyEditForm from "./ReplyEditForm";
import { getCSRFToken } from "../../utils/helperFunctions";

const PostCardItem = ({ post }: { post: PostType }) => {
  let { user } = useContext(AuthContext);
  const currentUser: UserType = user;
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  return (
    <div>
      <Card sx={{ minWidth: 300, marginTop: 3 }} elevation={2}>
        <CardContent>
          <Typography component="div"></Typography>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: post?.content }}
              style={{ whiteSpace: "pre-wrap" }}
            />
            <div>
              {(currentUser?.id?.toString().trim() ===
                post?.creator_id?.toString().trim() ||
                currentUser?.bemerkung === "GF") && (
                <IconButton
                  aria-label="settings"
                  onClick={() => setSettingsMenuOpen(!settingsMenuOpen)}
                >
                  <MoreVertIcon />
                </IconButton>
              )}
              {settingsMenuOpen && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 1,
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <ReplyEditForm initialPost={post} />
                  <Button
                    variant="outlined"
                    onClick={async () => {
                      try {
                        const response = await fetch(`/api/updatePosts/`, {
                          method: "DELETE",
                          headers: {
                            "Content-Type": "application/json",
                            "X-CSRFToken": getCSRFToken(),
                          },
                          body: JSON.stringify({
                            id: post.id,
                          }),
                        });

                        if (response.ok) {
                          // Redirect to forum main page or show a success message
                          window.location.reload();
                        } else {
                          console.error("Failed to delete post");
                        }
                      } catch (error) {
                        console.error("Error deleting post:", error);
                      }
                    }}
                    style={{
                      maxWidth: "180px",
                      maxHeight: "32px",
                      minWidth: "100px",
                      minHeight: "32px",
                    }}
                  >
                    Löschen
                  </Button>
                </div>
              )}
            </div>
          </div>

          <Typography sx={{ m: 1, p: 1 }} color="text.secondary">
            <Link to={`/profile/${post?.creator_id}`} style={{ color: "grey" }}>
              {post?.creator}
            </Link>{" "}
            am {moment(post?.updated).locale("de").format("DD.MM.YYYY HH:mm")}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default PostCardItem;
